// src/features/records/services/edges/search.js

import { functions } from '../../../../firebase';
import { httpsCallable } from 'firebase/functions';
import { requireUser } from '../utils/auth';

const searchRecordsFn = httpsCallable(functions, 'searchRecords');

/**
 * Search edges with text query.
 */
export async function searchEdges({
  uid: _uid,
  viewType,
  scope,
  searchTerm,
  ordering,
  page: _page = 0,
  pageSize = 30,
  cursor = null,
  geo = null
}) {
  requireUser();
  void _uid;
  void _page;

  try {
    const normalizedPageSize = Math.min(Math.max(1, pageSize || 1), 50);
    const searchRequest = {
      q: searchTerm || '',
      page: {
        size: normalizedPageSize,
        cursor: cursor
      }
    };

    if (viewType && viewType !== 'all') {
      searchRequest.view = viewType;
    }

    if (ordering) {
      searchRequest.ordering = ordering;
    }

    if (scope) {
      const normalizedScope = {};

      if (scope.ownerIds && Array.isArray(scope.ownerIds) && scope.ownerIds.length > 0) {
        normalizedScope.ownerIds = scope.ownerIds.slice(0, 10);
      }

      if (scope.groupIds && Array.isArray(scope.groupIds) && scope.groupIds.length > 0) {
        normalizedScope.groupIds = scope.groupIds.slice(0, 10);
      }

      if (scope.mode === 'users' && Array.isArray(scope.userIds) && scope.userIds.length > 0) {
        normalizedScope.ownerIds = scope.userIds.slice(0, 10);
      } else if (scope.mode === 'group' && scope.groupId) {
        normalizedScope.groupIds = [scope.groupId];
      }

      if (Object.keys(normalizedScope).length > 0) {
        searchRequest.scope = normalizedScope;
      }
    }

    if (geo) {
      const geoPayload = {};

      if (geo.aroundLatLng) {
        const { lat, lng } = geo.aroundLatLng;
        if (Number.isFinite(lat) && Number.isFinite(lng)) {
          geoPayload.aroundLatLng = { lat, lng };
          if (Number.isFinite(geo.aroundRadius)) {
            geoPayload.aroundRadius = geo.aroundRadius;
          }
        }
      }

      if (Array.isArray(geo.insideBoundingBox) && geo.insideBoundingBox.length > 0) {
        const boxes = geo.insideBoundingBox
          .filter((box) => Array.isArray(box) && box.length === 4)
          .map((box) => box.map((value) => Number(value)))
          .filter((parsed) => parsed.every((value) => Number.isFinite(value)));

        if (boxes.length) {
          geoPayload.insideBoundingBox = boxes;
        }
      }

      if (Object.keys(geoPayload).length > 0) {
        searchRequest.geo = geoPayload;
      }
    }

    const result = await searchRecordsFn(searchRequest);

    const items = (result.data.hydratedEdges || []).map((edge) => ({
      id: edge.recordId || edge.id,
      preview: edge.preview,
      edge: edge
    }));

    return {
      items,
      hasMore: !!result.data.nextCursor,
      nextCursor: result.data.nextCursor || null
    };
  } catch (error) {
    console.error('Search failed:', error);
    throw new Error(`Search failed: ${error.message}`);
  }
}
